// import Cookies from 'js-cookie'

const bookTokenKey = 'token'
const ReToken = 'RefreshToken'
// const editableTabsValue = '/bookShelf'
// const editableTabs = [{title: '书架', name: '/bookShelf', close: false}]

export function getToken () {
  return localStorage.getItem(bookTokenKey)
}
export function setToken (token) {
  return localStorage.setItem(bookTokenKey, token)
}
export function removeToken () {
  return localStorage.removeItem(bookTokenKey)
}
export function getRefreshToken () {
  return localStorage.getItem(ReToken)
}
export function setRefreshToken (RefreshToken) {
  return localStorage.setItem(ReToken, RefreshToken)
}
export function removeRefreshToken () {
  return localStorage.removeItem(ReToken)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js